<mat-card>
    <mat-card-header>
        <mat-card-title>

        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="text-center m-y-30">
        <div class="table-responsive m-t-30">
            <table class="table w-100">
                <thead class="heading">
                    <tr>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">Tipologia</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">Descrizione</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">Potenza impianto kWp</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">kWh prodotti</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">Incentivo CER</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">kWh immessi</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">% rispetto a totale immesso</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">kWh immessi/scambiati</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">kWh consumati/scambiati</th>
                        <th class="f-w-500 mat-subtitle-1 f-s-14">Totale TIP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Prosumer</td>
                        <td>Prosumer 1</td>
                        <td>3</td>
                        <td>1.000</td>
                        <td>0,11</td>
                        <td>250</td>
                        <td>20%</td>
                        <td>200</td>
                        <td>150</td>
                        <td>22,00 €</td>
                    </tr>
                    <tr>
                        <td>Consumer</td>
                        <td>Consumer 1</td>
                        <td></td>
                        <td></td>
                        <td>0,11</td>
                        <td></td>
                        <td>0%</td>
                        <td></td>
                        <td>150</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Consumer</td>
                        <td>Consumer 2</td>
                        <td></td>
                        <td></td>
                        <td>0,11</td>
                        <td></td>
                        <td>0%</td>
                        <td></td>
                        <td>200</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Prosumer</td>
                        <td>Prosumer 2</td>
                        <td>14</td>
                        <td>12.000</td>
                        <td>0,11</td>
                        <td>1.000</td>
                        <td>80% </td>
                        <td>850</td>
                        <td>550</td>
                        <td>93,50 €</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr style="font-weight: bold;">
                        <td colspan="5" style="border: none;text-align:left;">Totali</td>
                        <td>1.250</td>
                        <td>100%</td>
                        <td>1050</td>
                        <td>1050</td>
                        <td>115,50 €</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </mat-card-content>
    <mat-card-footer></mat-card-footer>
</mat-card>